import React, { useState } from "react";
import Box from "@mui/material/Box";
import ItemIdAssetModal from "./ItemIdAssetModal";
import AssetModal from "../../inventory/requests/asset-details/AssetModal";
import { ProjectProvider } from "../../../contexts/project";
import { CaptureProvider } from "../../../contexts/capture";
import { AssetsProvider } from "../../../contexts/assets";
import CollectionProvider from "../../capture/CollectionProvider";

export default function ItemId({ asset, editable = false, showOnlySave = false }) {
  const { itemId, id, project } = asset || {};
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    setOpen(v => !v);
  };

  return (
    <>
      <Box
        underline="none"
        sx={{ cursor: "pointer" }}
        color="primary.main"
        className="unfocus"
        onClick={handleToggle}
      >
        {itemId}
      </Box>
      {open && project?.id && !editable && (
        <ProjectProvider id={project.id} loadingComponent={<span />}>
          <ItemIdAssetModal id={id} onClose={handleToggle} />
        </ProjectProvider>
      )}
      {open && project?.id && editable && (
        <ProjectProvider id={project.id} loadingComponent={<span />}>
          <CaptureProvider>
            <CollectionProvider>
              <AssetsProvider>
                <AssetModal id={id} onClose={handleToggle} open={true} showOnlySave={showOnlySave} />
              </AssetsProvider>
            </CollectionProvider>
          </CaptureProvider>
        </ProjectProvider>
      )}
    </>
  );
}
